import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'react-relay';
import { DealsQuery } from './__generated__/DealsQuery.graphql';
import Offers from '../Offers/Offers';
import Txt from '../../atoms/Txt/Txt';
import { useRouter } from 'next/router';
import { PROMOTION_TAG } from 'utils/offers';

export interface Props {}

export const QUERY = graphql`
  query DealsQuery($requiredTags: [String!], $promoTags: [String!]) {
    deals(input: { requiredTags: $requiredTags }) {
      ...Offers_offers
    }
    dealsPromos: deals(input: { requiredTags: $promoTags }, first: 1) {
      ...OfferPromoBanner_promos
    }
  }
`;

const Deals: React.FC<Props> = () => {
  const router = useRouter();
  const category = Array.isArray(router.query.category)
    ? router.query.category[0]
    : router.query.category;
  const data = useLazyLoadQuery<DealsQuery>(
    QUERY,
    {
      requiredTags: [category].filter(Boolean) as string[],
      promoTags: [category, PROMOTION_TAG].filter(Boolean) as string[],
    },
    {
      fetchPolicy: 'store-or-network',
    },
  );
  return data.deals ? (
    <Offers offersRef={data.deals} promosRef={data.dealsPromos} offerType="deal" />
  ) : (
    <Txt component="p">We are having trouble loading deals at the moment.</Txt>
  );
};

export default Deals;
